import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const NoteContainer = styled.div({
  background: v.bgSoftGray,
  borderRadius: '5px',
  marginTop: '1rem',
  fontSize: '1rem',
  padding: '10px',
  display: 'flex',
  flexDirection: 'column',

  'span.noteTitle': {
    fontWeight: 'bold', 
    fontSize: '1.2rem'
  },

  'span.noteRemark': {
    fontWeight: 'bold',
  },
})
